import { ReactNode } from "react";

import { Button } from "@smart/itops-sb-design-system-dom";

import { GroupContainer, GroupFieldSetContainer } from "./group-components";
import { GroupItem } from "../types";

export type IntakeGroupProps = {
  group: GroupItem;
  onAdd?: () => void;
  children?: ReactNode;
};

export type IntakeGroupSetProps = {
  group: GroupItem;
  index: number;
  onRemove?: () => void;
  children?: ReactNode;
};

export const IntakeGroup = ({ group, children, onAdd }: IntakeGroupProps) => (
  <GroupContainer group={group}>
    {children}
    {onAdd && (
      <div className="mt-[-0.8rem]">
        <Button
          leftIcon="regularPlus"
          variant="primarySubtle"
          onClick={onAdd}
          text={group.repeatPrompt || "Add"}
          dataTestId="add-button"
        />
      </div>
    )}
  </GroupContainer>
);

export const IntakeGroupFieldSet = ({
  group,
  index,
  onRemove,
  children,
}: IntakeGroupSetProps) => (
  <GroupFieldSetContainer group={group} index={index}>
    {children}
    {onRemove && (
      <div className="flex items-start">
        <Button
          variant="secondarySubtle"
          leftIcon="regularTrashCan"
          text="Delete"
          onClick={onRemove}
          className="text-red-550"
          dataTestId="remove-button"
        />
      </div>
    )}
  </GroupFieldSetContainer>
);
